import React from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import API from "../../Services/BaseService";
import { useHistory, useLocation, useParams } from "react-router-dom";
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import checkImg from '../../assets/img/check.svg';
import errorImg from '../../assets/img/erroricon.png';
import "../../Component/CommonPopup/commonPopup.css";
import upload from "../../assets/img/upload.png"
import { Modal } from 'react-bootstrap';

const DeliverInfo = (props) => {
    console.log("props", props)
    const history = useHistory();
    const [deliverError, setDeliverError] = useState("");
    const [transportError, setTransportError] = useState("");
    // const { id } = useParams();
    const sellerData = useSelector(state => state.LoginReducer.payload);
    const [isCommonPopupOpen, setIsCommonPopupOpen] = useState(false);
    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("");
    // const [userNameError,setUsernameError] = useState("");
    const [infoFlag, setInfoFlag] = useState(false);
    const [alertmessage, setAlertMessage] = useState("");
    const [alerttitle, setAlertTitle] = useState("");
    const [alertimg, setAlertImg] = useState("");
    // const [transportMode, setTransportMode] = useState(props?.carDetail.transportation_mode);
    // const [deliveryInfo, setDeliveryInfo] = useState(props?.carDetail.cardelivery_info);

    const [toggleAcceptPopupOpen, setToggleAcceptPopupOpen] = useState(true);
    const [firstName, setFirstName] = useState(props?.carDetail.first_name);
    const [transportationName, setTransportationName] = useState(props?.carDetail.transportation_name);

    const [lastName, setLastName] = useState(props?.carDetail.last_name);
    const [transCheck, setTransCheck] = useState(props?.carDetail.transaction_check);
    const [driverLic, setDriverLic] = useState(props?.carDetail.driver_license);
    const [uploadDriverLic, setUploadDriverLic] = useState("");
    const [notes, setNotes] = useState(props?.carDetail.notes);
    const [firstNameError, setFirstNameError] = useState("");
    const [lastNameError, setLastNameError] = useState("");
    const [driverLicError, setDriverLicError] = useState("");
    const [carInfoId, setCarInfoId] = useState(props?.carDetail.car_delivery_info_id);
    const [transportationNameError, setTransportationNameError] = useState("");
    const [driverDocError, setDriverDocError] = useState("");

    const [uploadDriverLicShow, setUploadDriverLicShow] = useState("");
    console.log("uploadDriverLicShow", uploadDriverLicShow)
    console.log("uploadDriverLic", uploadDriverLic)
    console.log("transCheck", transCheck)
    console.log("transportationName", transportationName)
    const toggleCommonPopup = () => {
        setIsCommonPopupOpen(!isCommonPopupOpen);
    }

    const addNewInfo = () => {
        // setDeliverError("");
        // setTransportError("")
        setFirstNameError("");
        setLastNameError("");
        setDriverLicError();
        setTransportationNameError("")
        // if (!deliveryInfo) {
        //     setDeliverError("delivery Information is required");
        //     return;
        // } else if (deliveryInfo.length > 250) {
        //     setDeliverError("delivery Information must not exceed 250 characters");
        //     return;
        // }
        // if (!transportMode) {
        //     setTransportError("Mode of Transport is required");
        //     return;
        // }
        if (!firstName) {
            setFirstNameError("FirstName is Required")
            return;
        }
        if (!lastName) {
            setLastNameError("LastName is Required")
            return;
        }
        if (!driverLic) {
            setDriverLicError("Driver License is Required")
            return;
        }
        if (transCheck == 1) {
            if (!transportationName) {
                // setLastNameError("LastName is Required")
                setTransportationNameError("Transportation Name is Required");
                return;
            }

        }
        setInfoFlag(true)
    }

    const getDeliveryInfo = () => {

        let request = {
            bill_of_sale_id: props?.billofSaleId,
            car_id: props?.carId,
            first_name: firstName,
            last_name: lastName,
            driver_license: driverLic,
            notes: notes,
            driver_lic_doc: uploadDriverLic ? [uploadDriverLic] : "",
            car_delivery_info_id: carInfoId,
            // delivery_info: deliveryInfo,
            // transportation_mode: transportMode,
            transaction_check: transCheck ? transCheck : "",
            transportation_name: transCheck == 1 && transportationName ? transportationName : "",
            seller_id: sellerData.seller_id,
            seller_token: sellerData.seller_token,
            updatedBy: sellerData.seller_id,
            createdBy: sellerData.seller_id,
        }

        console.log("Gate Pass request: ", request);
        API.post("car_delivery_info/update", request).then(response => {

            console.log("===Gate Pass response===", response)
            if (response.data.success) {
                console.log("registration response=>", response)
                props.recallDeliver();
                setToggleAcceptPopupOpen(false);
                setAlertImg(checkImg);
                setAlertTitle("Car Delivery Information")
                setAlertMessage("Car Delivery Information Successfully Added")

            } else {
                const { data } = response;
                setToggleAcceptPopupOpen(false);
                setAlertImg(errorImg);
                setAlertMessage(data.error.err)

            }

        })
    }
    const isValidFile = (file) => {
        let filesArray = Object.values(file);
        let fileExtension = filesArray[0].split('.').pop();

        let isValid = (
            fileExtension == 'doc' ||
            fileExtension == 'docx' ||
            fileExtension == 'pdf' ||
            fileExtension == 'png' ||
            fileExtension == 'jpeg' ||
            fileExtension == 'jpg');
        return isValid;
    }
    const getFiles = (file) => {

        setDriverDocError("")

        if (!isValidFile(file)) {
            setDriverDocError("Only DOC/DOCX,PDF,JPG,PNG,JPEG file formats can be uploaded");
        }
        else {
            setUploadDriverLic(file)
            setUploadDriverLicShow(file.name)
        }
    }
    const transportationcheck = () => {
        setTransportationNameError("")
        document.getElementById("transportcheck")?.checked ? setTransCheck(1) : setTransCheck(0);


    }
    const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    const ext = file.name.split(".").pop().toLowerCase();

    const allowed = ["doc", "docx", "pdf", "png", "jpg", "jpeg"];

    if (!allowed.includes(ext)) {
        setDriverDocError(
            "Only DOC, DOCX, PDF, JPG, JPEG and PNG files are allowed."
        );
        return;
    }

    const reader = new FileReader();

    reader.onload = () => {
        const base64 = reader.result.split(",")[1];

        const uploadFile = {
            name: file.name,
            type: file.type,
            size: file.size,
            base64: base64
        };

        setDriverDocError("");
        setUploadDriverLic(uploadFile);
        setUploadDriverLicShow(file.name);
    };

    reader.readAsDataURL(file);
};
    return (

        <div>



            <div className="">
                {toggleAcceptPopupOpen && infoFlag == false ?
                    <Modal show={true} onHide={props.toggle} centered>
                        <Modal.Header className="Terms-login">
                            <h2 >Delivery Information</h2>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="row">
                                <div class="col-sm-12 tbox m-0 mb-3">
                                    <input type="text" class="form-control" id="FirstName" defaultValue={firstName}
                                        onChange={(e) => setFirstName(e.target.value)} />
                                    <label for="FirstName" class="input-has-value required" >First Name</label>
                                    <p className="form-input-error" >{firstNameError}</p>

                                </div>

                                <div class="col-sm-12 tbox m-0 mb-3">
                                    <input type="text" class="form-control" id="LastName" defaultValue={lastName}
                                        onChange={(e) => setLastName(e.target.value)} />
                                    <label for="LastName" class="input-has-value required" >Last Name</label>
                                    <p className="form-input-error" >{lastNameError}</p>
                                </div>
                                <div class="col-sm-12 tbox m-0 mb-2">
                                    <input type="text" class="form-control" id="DriverLic" defaultValue={driverLic}
                                        onChange={(e) => setDriverLic(e.target.value)} />
                                    <label for="DriverLic" class="input-has-value required" >Driver license</label>
                                    <p className="form-input-error " >{driverLicError}</p>

                                </div>
                                <div class="transcheck3 mb-4 mt-0">Transportation Check

                                    <span className="">
                                        <input type="checkbox" className="checktrans" id="transportcheck" value={transCheck == 0 ? 1 : 0}
                                            checked={transCheck == 1 ? true : false}
                                            onChange={(e) => transportationcheck()} />
                                    </span>
                                </div>
                                {transCheck == 1 ?
                                    <div class="col-sm-12 tbox m-0 mb-3">
                                        <input type="text" class="form-control" id="transname" defaultValue={transportationName}
                                            onChange={(e) => setTransportationName(e.target.value)} />
                                        <label for="transname" class="input-has-value required" >Transportation Name</label>

                                    </div>
                                    : ""}
                                <p className="form-input-error " >{transportationNameError}</p>


                                <div class="col-sm-12 tbox m-0 mb-3">
                                    <textarea type="text" class="form-control" id="Notes" defaultValue={notes}
                                        onChange={(e) => setNotes(e.target.value)} />
                                    <label for="Notes" class="input-has-value" >Notes</label>
                                </div>

                                <div className="upload-btn-wrapper uploadlic1">
                                    <label className="btn forcolor1">
                                        <img src={upload} alt="" /> Upload Driver License
                                        <input
                                            type="file"
                                            hidden
                                            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                            onChange={handleFileChange}
                                        />
                                    </label>
                                </div>
                            </div>


                            {uploadDriverLicShow ?
                                <p className="drivershow adrivershow">{uploadDriverLicShow}</p> :
                                <p className="drivershow"><a className="adrivershow" href={props?.carDetail.driver_lic_doc} target="_blank">{props?.carDetail.driver_lic_doc?.split("_")[1]}</a></p>
                            }

                            <p className="form-input-error">{driverDocError}</p>
                            <div className="col-md-12 text-center paybtns">
                                <button className="redBtn carHistory" onClick={addNewInfo}>Add</button>
                                <button className="redBtn carHistory" onClick={props.toggle}>Close</button>
                            </div>
                        </Modal.Body>
                    </Modal> :
                    toggleAcceptPopupOpen && infoFlag == true ?
                        <Modal show={true} onHide={props.toggle} centered>
                            <Modal.Header className="Terms-login">
                                <h2 >Delivery Info Confirmation</h2>
                            </Modal.Header>
                            <Modal.Body>
                                <p>Are You Sure You Want to Change the Delivery Information</p>
                                <div className="col-md-12 text-center paybtns mt-5">
                                    <button className="redBtn carHistory" onClick={getDeliveryInfo}>Yes</button>
                                    <button className="redBtn carHistory" onClick={props.toggle}>Cancel</button>
                                </div>
                            </Modal.Body>
                        </Modal> :

                        <Modal show={true} onHide={props.toggle} centered>
                            <Modal.Header className="Terms-login">
                                <h2 className='common'>{alerttitle}</h2>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="modalcontent">
                                    <div className="Commonfull-icon">
                                        <img alt="" className={alertimg === checkImg ? "successImg " : "errorImg"} src={alertimg}></img>
                                    </div>
                                    <div className="modalbody">
                                        <h2 className="title">{alerttitle}</h2>
                                        <p className="text-center">{alertmessage}</p>
                                        <div className="col-md-12 btns">
                                            <button className="cta-btns" onClick={props.toggle}>ok</button>
                                        </div>
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>
                }
            </div>



            {isCommonPopupOpen && <CommonPopup
                handleClose={isCommonPopupOpen}
                popupTitle={popupTitle}
                popupMsg={popupMsg}
                popupType={popupType}
                popupActionType={popupActionType}
                popupActionValue={popupActionValue}
                popupActionPath={popupActionPath}
            />}
        </div>
    )
}

export default DeliverInfo